'use client';

import { PageViewData } from '../types';
import {
  generatePageViewData,
  getWindowTrackerState,
  serializeTrackingProps,
  setWindowTrackerState,
  TRACKER_ENABLED,
} from '../utils';
import { getUtag } from './utag';
import { logger } from '../utils';
import { EVENT_PAGE_VIEW_SENT } from '../utils/event-names';

export const trackPageView = (data: Partial<PageViewData> | undefined) => {
  if (!TRACKER_ENABLED) {
    return;
  }

  let ready = getWindowTrackerState().ready;

  if (ready) {
    let enrichedData = {
      ...generatePageViewData(),
      ...filterUndefined(data ?? {}),
    };

    let serialized = serializeTrackingProps(enrichedData);

    try {
      getUtag(window)?.view({ ...serialized });
      logger.log('Page View: Sent.', serialized);
    } catch (e) {
      console.error('Could not send page view to utag.', e);
    }

    setWindowTrackerState(prev => ({
      ...prev,
      pageViewContext: enrichedData,
      meta: {
        ...prev.meta,
        pathname: window.location.pathname,
      },
    }));

    window.dispatchEvent(new Event(EVENT_PAGE_VIEW_SENT));

    return;
  }

  logger.log('Page View: Queued.', data ?? {});

  setWindowTrackerState(current => ({
    ...current,
    pageViewQueue: [...current.pageViewQueue, data ?? {}],
  }));
};

const filterUndefined = (obj: Partial<PageViewData>): Partial<PageViewData> => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== undefined),
  );
};
